import { getYTEmbedUrl } from "@routes/Article/components/ArticleParagraphElements/utils/helpers";
import { Type } from "@typings/enums";
import { cn } from "@util/helpers";

export type YouTubeVideoProps = {
  /** The YouTube video URL to be embedded. */
  src: string;
  /** Optional CSS class to apply to the video container. */
  className?: string;
  /** Optional title for the video, used for accessibility. */
  title?: string;
};

/**
 * YouTubeVideo component that renders an embedded YouTube video.
 */
const YouTubeVideo = ({
  src,
  className,
  title,
}: YouTubeVideoProps): React.ReactElement => {
  const url = new URL(src);

  return (
    <div
      className={className}
      data-story-element={Type.YoutubeVideo}
      data-testid="youtube-video-component"
    >
      <iframe
        className={cn("mx-auto aspect-video w-full", {
          "aspect-9x16 max-w-80": url.pathname.includes("/shorts/"),
        })}
        src={getYTEmbedUrl(src)}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        title={title}
      ></iframe>
    </div>
  );
};

export default YouTubeVideo;
